export const css = {
    root: 'vb2Yk_e9',
    ' _key': 'apic-theme/apic/variants/ltccip2'
};
export default css;
